var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIaXsABsO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311.000000, -572.000000) translate(311.000000, 572.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#25BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.931 24.931L14.053 28.021 15.175 21.476 10.42 16.841 16.992 15.886 19.931 9.931 22.87 15.886 29.441 16.841 24.686 21.476 25.809 28.021z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaXsABsO);
export default __webpack_public_path__ + "static/media/IaXsABsO.4ad3f23ba96b659de5b6904b37eef998.svg";
export { ForwardRef as ReactComponent };